import actions from './action'
import store from '@ps/store'
import { getWholeBranch } from './brain'
import { isEqual } from 'lodash-es'
import { getRelativeSameVideoSceneNode } from '@ps/store/interactive-video/brain/brain'

function getInitState() {
  return {
    brainData: [],
    copyBrainSceneUuid: '',
  }
}

function setBrain(data) {
  const gamePlay = store.state.workspace.game.gamePlay
  const ped = gamePlay.getScript('playsmart.editor.data')
  data.forEach((item) => {
    if (item.sync === 1) {
      item.sync =
        getRelativeSameVideoSceneNode(item.sceneUuid).length > 1 ? 1 : 0
    }
  })
  ped.$data.brain = data
}

let previousBrainBranchUuids
let previousActiveSceneId
export const returnAndSavedAsPrevious = (activeSceneId, brainBranchUuids) => {
  previousActiveSceneId = activeSceneId
  previousBrainBranchUuids = [...brainBranchUuids]
  return brainBranchUuids
}

const getWholeBranchByLeaf = (uuids, brainData) => {
  uuids = uuids || []
  brainData = brainData || []

  const closerLeafUuid = uuids.findLast((uuid) =>
    brainData.find((item) => item.sceneUuid === uuid),
  )

  if (closerLeafUuid) {
    return getWholeBranch(closerLeafUuid, brainData)
  }

  return []
}

export default {
  namespaced: true,
  state: getInitState(),
  mutations: {
    updateBrainData(state, data) {
      state.brainData = data
      setBrain(state.brainData)
    },
    addBrainItem(state, data) {
      state.brainData = state.brainData.concat(data)
      setBrain(state.brainData)
    },
    updateCopyId(state, uuid) {
      state.copyBrainSceneUuid = uuid
    },
  },
  getters: {
    brainBranchUuids(state, getters, rootState) {
      const data = state.brainData
      const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
      if (!currentSceneNode) {
        return []
      }

      if (currentSceneNode && data) {
        const regetOldBranch =
          previousActiveSceneId && previousBrainBranchUuids
            ? getWholeBranchByLeaf(
                previousBrainBranchUuids || [previousActiveSceneId],
                data,
              )
            : undefined

        if (
          previousBrainBranchUuids &&
          Array.isArray(previousBrainBranchUuids) &&
          previousBrainBranchUuids.includes(currentSceneNode.uuid) &&
          // 每个旧值都应该还是有效值
          // 场景新增，删除场景的case(因为可能导致这个策略返回的旧值不符合预期)
          (regetOldBranch
            ? isEqual(regetOldBranch, previousBrainBranchUuids)
            : false)
        ) {
          return returnAndSavedAsPrevious(
            currentSceneNode.uuid,
            previousBrainBranchUuids,
          )
        }

        return returnAndSavedAsPrevious(
          currentSceneNode.uuid,
          getWholeBranch(currentSceneNode.uuid, data),
        )
      }

      return returnAndSavedAsPrevious(
        currentSceneNode && currentSceneNode.uuid,
        [],
      )
    },
    // 和当前场景同视频可以关联的场景节点
    relativeSameVideoSceneNode(state, getters, rootState) {
      const currentSceneNode = rootState.workspace.sceneManager.currentSceneNode
      return getRelativeSameVideoSceneNode(
        currentSceneNode ? currentSceneNode.uuid : '',
      )
    },
  },

  actions: {
    ...actions,
  },
}
